import { Box } from '@mui/material'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import DetailComponent from './detail'
import { useGetCompanyByIdQuery, useGetCompanyAnalyticsQuery } from '../../store/api/adminApi'

const SubscriberDetailComponent = () => {
  const { id } = useParams()

  const {
    data: companyData,
    isLoading: userDataLoader,
    refetch: refetchCompany,
  } = useGetCompanyByIdQuery(id, { skip: !id })

  const userData = companyData?.company ?? {}
  const { data: analyticsRaw } = useGetCompanyAnalyticsQuery(id, { skip: !id })
  const analyticsData = analyticsRaw?.analyticsData ?? null

  useEffect(() => {
    if (userData?.companyName) {
      document.title = `${userData.companyName} | PieceWorkPro Admin Panel`
    }
    return () => {
      document.title = 'PieceWorkPro Admin Panel'
    }
  }, [userData?.companyName])

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <DetailComponent
        isLoading={userDataLoader}
        subscriberData={userData}
        companySetting={companyData?.companySetting ?? null}
        analyticsData={analyticsData}
        onRefetch={refetchCompany}
      />
    </Box>
  )
}

export default SubscriberDetailComponent
